import * as types from "../mutation-type"
import axios from "axios/index";


export default {
  state: {
    faqs: {
      info:[]
    },
  },
  mutations: {
    [types.SET_FAQ](state, payload) {
      state.faqs.info = payload.info
    },

  },
  actions: {
    getFaq({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "faq/all"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_FAQ,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },

  }
}
